import {createContext, useCallback, useContext, useState} from 'react'
import {COLOR_MODE_STORAGE_KEY} from 'services/theme'

const ColorModeContext = createContext(undefined)

export const ColorModeProvider = ({children}) => {
    const [mode, setMode] = useState(() =>
        typeof window !== 'undefined'
            ? localStorage.getItem(COLOR_MODE_STORAGE_KEY) || 'light'
            : 'light'
    )

    const toggleColorMode = useCallback(() => {
        setMode((prev) => (prev === 'light' ? 'dark' : 'light'))
    }, [])

    return (
        <ColorModeContext.Provider value={{mode, setMode, toggleColorMode}}>
            {children}
        </ColorModeContext.Provider>
    )
}

export const useColorMode = () => {
    const context = useContext(ColorModeContext)

    if (!context) {
        throw new Error('useColorMode must be used within a ColorModeProvider')
    }

    return context
}

export default ColorModeContext
